import ReactSelectCustomArrowIndicator from './ReactSelectCustomArrowIndicator';

export default ReactSelectCustomArrowIndicator;